import { __remove, __set } from "../store/axios_indicator";
import Api from "./APIHandler";
import CheckOut from "@system/config/checkout";

const API = new Api({});

class CheckoutAPICall {

    uploadTaxExempt = async (params) => {
        __set('TAX_EXEMPT_FILE_UPLOAD');
        let res = {};
        const param = {}
        param.data = params;
        param.data.isMultipart = true;
        await API.post(CheckOut.TAX_EXEMPT_FILE_UPLOAD, param).then((resHer) => {
            res = resHer?.data;
            __remove('TAX_EXEMPT_FILE_UPLOAD');
        }).catch((e) => {
            res = false;
            __remove('TAX_EXEMPT_FILE_UPLOAD');
        })
        return res;
    }
    
}

export default CheckoutAPICall;